<div *ngIf="me?.timezone" class="dropdown" [class.mobile]="deviceService.isMobile()" (clickOutside)="closeList()">
  <div class="label" (click)="toggleList()">
    <span class="title">{{ timezone }}</span>
  </div>
  <div class="options" [class.open]="listOpened">
    <ng-container *ngTemplateOutlet="option"></ng-container>
  </div>
</div>

<ng-template #option>
  <div class="search-wrap">
    <input type="text" [(ngModel)]="searchQuery" [placeholder]="'tutors.search' | translate" class="search-input"/>
  </div>

  <div *ngFor="let option of filteredTimezones(); trackBy: trackByFn" class="option"
       (click)="setTimezone(option.value)">
    <span class="title">{{ option.title | translate }}</span>
  </div>
</ng-template>
